// extracted by mini-css-extract-plugin
export default {"mainContent":"approvedleave_mainContent__W2Z1y"};